import React, { useEffect, useState } from "react";
import styles from "./CollectionsHeader.module.css";
import { Button, Col, Dropdown, Radio, Row, Space, Image, Alert, Typography } from "antd";
import { Header } from "antd/es/layout/layout";
import Title from "antd/es/typography/Title";
import { useDispatch, useSelector } from "react-redux";
import { fetchPublicCollections, setSortBy } from "../../Slices/PublicCollectionsDataSlice";
import LoginModal from "../LoginModal/LoginModal";
import FilterIcon from '../../Icons/sort.png'
import Marquee from "react-fast-marquee";
import askAiIcon from '../../Icons/NotableHQ AI Icon.jpeg'
import { useNavigate, useSearchParams } from "react-router-dom";
import type { MenuProps } from "antd";

const {  Text } = Typography;

type Props = {};

const CollectionsHeader = (props: Props) => {
  const isLogin = useSelector((state:any) => state.userActions.isLogin)
  const sortBy = useSelector((state:any)=> state.publicCollectionsData.sortBy)
  const [searchParams, setSearchParams]:any = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const collectionsLoader = useSelector(
    (state: any) => state.publicCollectionsData.collectionsLoader
  );
  const [loginModal, setLoginModal] = useState(false);

  
  const handleSort = (sortBy:any) => {
    searchParams.set('sortBy', sortBy)
    setSearchParams(searchParams)

    // console.log(searchParams.get('sortBy'))
    
    dispatch(fetchPublicCollections({page: searchParams.get('page'), search : searchParams.get('search'), sortBy : sortBy, perPage : searchParams.get('per_page')}));
  };

  // useEffect(()=>{
  //   dispatch(fetchPublicCollections({page: searchParams.get('page'), search : searchParams.get('search'), sortBy : searchParams.get('sortby'), perPage : searchParams.get('per_page')}));
  // }, [searchParams.get('sortBy')])


  const onLoginCancel = ()=>{
    setLoginModal(false);
  }

  const items: MenuProps['items'] = [
    {
      key: "1",
      type: "group" as const,
      label: "Sort By",
      children: [
        {
          key: "1-1",
          label: (
            <Radio.Group defaultValue={searchParams.get('sortBy')} value={searchParams.get('sortBy') ?? 'latest'} onChange={(e) => handleSort(e.target.value)}>
              <Space direction="vertical">
                <Radio value={"latest"}>Latest</Radio>
                <Radio value={"popularity"}>Most Liked</Radio>
                <Radio value={"name"}>Name</Radio>
              </Space>
            </Radio.Group>
          ),
        },
      ],
    },
  ];

  return (
    <>
             { (searchParams.get('ai') ) &&
    <Alert
    // banner
    icon={<Image src={askAiIcon} height={25} width={25} preview={false} />}
    showIcon={true}
    className={styles.askAiLoading}
    type={"info"}
    message={collectionsLoader ?  <Text style={{marginLeft: "8px", fontWeight: "bold"}} >
          AI is thinking about your query.. 
           </Text> : <Text style={{marginLeft: "8px", fontWeight: "bold"}}>Your Search Results Are In!</Text>}
    description={(!collectionsLoader && window.innerWidth > 768 ) && <Text style={{marginLeft: "8px"}}  >Hey there! Your search results are all set and waiting for you. Dive in and find what you need hassle-free!</Text>}
    // message={
    //   <Marquee pauseOnHover gradient={false}>
    //     {collectionsLoader ? 
    //     <Text style={{margin: "0", fontWeight: "bold"}} >
    //       AI is thinking about your query.. 
    //       </Text>
    //       : 
    //       <>
    //       <Text style={{margin: "0 25px 0 0", fontWeight: "bold"}}>Your Search Results Are In!</Text>
    //       <Text style={{margin: "0 50px 0 25px"}}>Hey there! Your search results are all set and waiting for you. Dive in and find what you need hassle-free!</Text>
    //       </>
    //     }
    //   </Marquee>
    // }
  />
}

      <Header
        className={styles.headerMain}
        style={{ borderRadius: "8px", marginBottom: "10px" }}
      >
        <Row className={styles.headerRow} align={"middle"}>
          <Col span={12}>
            <Dropdown
            overlayStyle={{minWidth: "unset"}}
              className={styles.dropdown}
              menu={{
                items,
              }}
            >
              <a onClick={(e) => e.preventDefault()}>
                <Space style={{display: "flex", alignItems: "center",}}>
                  <Title
                    className={styles.filterTitle}
                    style={{ color: "white" }}
                    level={5}
                  >
                    Filters
                  </Title>
                  <Image
                preview={false}
                className={` ${styles.cardTopIcon}`} style={{marginBottom: "2px"}} width={20} src={FilterIcon}/>                
                </Space>
              </a>
            </Dropdown>
          </Col>
          <Col
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
            }}
            span={12}
          >
            <Button onClick={()=> {isLogin ? window.location.pathname = '/dashboard/collections/create' : setLoginModal(true)}} type="primary">+ Publish Collection</Button>
          </Col>
        </Row>
      </Header>

      <LoginModal redirectUrl={'https://www.notablehq.com/dashboard/collections'} open={loginModal}  onCancel={onLoginCancel}/>
    </>
    
  );
};

export default CollectionsHeader;
